import styled, { css } from 'styled-components';
import { text, textLinkPrimary } from 'styles-js/mixins/typography';

export const LinkButton = styled.button`
  border: 0;
  padding: 0;
  -webkit-appearance: none;
  background-color: transparent;
  ${textLinkPrimary};
`;

const ButtonBase = css`
  ${text};
  display: inline-block;
  margin: 5px 5px 5px 0px;
  padding: 6px 12px;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  transition: all 0.7s ease;
  white-space: nowrap;
  text-align: center;
  vertical-align: middle;
  user-select: none;

  &:hover {
    text-decoration: none;
  }
  &:focus {
    outline: 0;
    box-shadow: 0 0 0 0.2rem ${({theme}) => theme.colorButtonFocus};
  }
`;

export const PrimaryButton = styled.button`
  ${ButtonBase};
  color: ${({theme}) => theme.colorButtonPrimaryText};
  background-color: ${({theme}) => theme.colorButtonPrimary};
  border: 1px solid ${({theme}) => theme.colorButtonPrimary};

  &:hover {
    color: ${({theme}) => theme.colorButtonPrimaryText};
    background: ${({theme}) => theme.colorButtonPrimaryHover};
    border: 1px solid ${({theme}) => theme.colorButtonPrimaryHover};
  }
`;
